{
  "admin.guard": {
    "loading": "Loading…"
  },
  "admin.layout": {
    "nav": {
      "label": "Main",
      "home": "Dashboard",
      "clinics": "Clinics",
      "staff": "Staff",
      "profile": "Profile",
      "password": "Change password"
    },
    "logout": "Log out",
    "logoutFailed": "Could not log out. Try again."
  },
  "admin.shell": {
    "brand": "Takove",
    "skipToContent": "Skip to content"
  },
  "admin.clinicNew": {
    "title": "New clinic",
    "name": "Clinic name",
    "timezone": {
      "label": "Time zone",
      "hint": "Choose carefully: the time zone cannot be changed afterwards. An operator corrects a mistake, only while the clinic has no appointments.",
      "zone": {
        "saoPaulo": "São Paulo, Rio, Brasília (UTC−3)",
        "noronha": "Fernando de Noronha (UTC−2)",
        "belem": "Belém (UTC−3)",
        "fortaleza": "Fortaleza (UTC−3)",
        "recife": "Recife (UTC−3)",
        "araguaina": "Araguaína (UTC−3)",
        "maceio": "Maceió (UTC−3)",
        "bahia": "Salvador, Bahia (UTC−3)",
        "campoGrande": "Campo Grande (UTC−4)",
        "cuiaba": "Cuiabá (UTC−4)",
        "portoVelho": "Porto Velho (UTC−4)",
        "boaVista": "Boa Vista (UTC−4)",
        "manaus": "Manaus (UTC−4)",
        "eirunepe": "Eirunepé (UTC−5)",
        "rioBranco": "Rio Branco (UTC−5)"
      }
    },
    "owner": {
      "legend": "Owner",
      "kind": "Owner account",
      "kindNew": "New staff account",
      "kindExisting": "Existing staff account",
      "email": "Owner email",
      "emailExistingHint": "The account must already exist and be active.",
      "name": "Owner name"
    },
    "cro": {
      "number": "CRO number",
      "uf": "CRO state",
      "noUf": "State"
    },
    "submit": "Create clinic",
    "error": {
      "emailTaken": "A staff account with this email already exists.",
      "ownerNotFound": "No staff account has this email.",
      "ownerDisabled": "This staff account is disabled.",
      "croPair": "Enter both the CRO number and state, or leave both empty.",
      "generic": "Could not create the clinic. Try again."
    }
  },
  "admin.clinic": {
    "back": "All clinics",
    "created": "Clinic {{name}} created.",
    "createdNewOwner": "The owner is a new account, so generate their set-password link under Staff.",
    "statusTitle": "Status",
    "createdAt": "Created on {{date}}",
    "closedSince": "Closed since {{date}}. Members can only read; nothing was deleted.",
    "suspendedSince": "Suspended since {{date}}. Members cannot access the clinic.",
    "action": {
      "close": "Close clinic",
      "reopen": "Reopen clinic",
      "suspend": "Suspend clinic",
      "unsuspend": "Lift suspension"
    },
    "reason": {
      "closeTitle": "Close clinic",
      "suspendTitle": "Suspend clinic",
      "label": "Reason",
      "hint": "It is recorded in the audit log.",
      "confirmClose": "Confirm closing",
      "confirmSuspend": "Confirm suspension",
      "cancel": "Cancel",
      "required": "Enter the reason."
    },
    "done": {
      "closed": "Clinic closed.",
      "reopened": "Clinic reopened.",
      "suspended": "Clinic suspended.",
      "unsuspended": "Suspension lifted."
    },
    "error": {
      "load": "Could not load the clinic. Try again.",
      "notFound": "Clinic not found.",
      "action": "Could not complete the action. Try again."
    }
  },
  "admin.clinics": {
    "title": "Clinics",
    "new": "New clinic",
    "search": "Search by name",
    "searchSubmit": "Search",
    "empty": "No clinics yet.",
    "emptySearch": "No clinics match that search.",
    "hasMore": "There are more clinics than shown. Narrow the search.",
    "col": {
      "name": "Name",
      "status": "Status",
      "members": "Members",
      "created": "Created on"
    },
    "status": {
      "active": "Active",
      "closed": "Closed",
      "suspended": "Suspended"
    },
    "error": {
      "load": "Could not load the clinics. Try again."
    }
  },
  "admin.clinicIdentity": {
    "title": "Clinic identity",
    "hint": "Only the clinic owner edits these details; here you can only view them.",
    "notInformed": "Not provided",
    "whatsapp": "WhatsApp",
    "cro": "CRO {{number}}/{{uf}}",
    "croNoUf": "CRO {{number}}",
    "fields": {
      "legalName": "Legal name",
      "cnpj": "CNPJ",
      "croRegistration": "Clinic CRO registration",
      "phone": "Phone",
      "email": "Email",
      "address": "Address",
      "technicalManager": "Technical manager"
    }
  },
  "admin.clinicMembers": {
    "title": "Active members",
    "empty": "This clinic has no active members.",
    "col": {
      "name": "Name",
      "email": "Email",
      "roles": "Roles",
      "since": "Since",
      "actions": "Actions"
    },
    "role": {
      "owner": "Owner",
      "dentist": "Dentist"
    },
    "technicalManager": "Technical manager",
    "action": {
      "roles": "Change roles",
      "rolesFor": "Change roles of {{name}}",
      "end": "End membership",
      "endFor": "End membership of {{name}}",
      "setTm": "Set as technical manager",
      "setTmFor": "Set as technical manager: {{name}}",
      "clearTm": "Remove technical manager",
      "clearTmFor": "Remove technical manager: {{name}}"
    },
    "add": {
      "title": "Add member",
      "email": "Staff account email",
      "emailHint": "The account must exist. Create it under Staff first if needed.",
      "roles": "Roles of the new member",
      "submit": "Add member"
    },
    "edit": {
      "title": "Change roles of {{name}}",
      "roles": "Roles of {{name}}",
      "save": "Save roles",
      "cancel": "Cancel"
    },
    "end": {
      "title": "End membership of {{name}}",
      "body": "The person loses access to this clinic. History is kept and the account still exists.",
      "confirm": "Confirm ending",
      "cancel": "Cancel"
    },
    "done": {
      "added": "{{name}} was added to the clinic.",
      "roles": "Roles of {{name}} updated.",
      "ended": "Membership of {{name}} ended.",
      "tmSet": "{{name}} is the technical manager.",
      "tmCleared": "{{name}} is no longer the technical manager."
    },
    "error": {
      "notFound": "No staff account has this email.",
      "disabled": "This account is disabled.",
      "cro": "The dentist role needs a CRO on the account.",
      "alreadyMember": "This account is already an active member of this clinic.",
      "lastOwner": "A clinic must keep at least one active owner.",
      "tmIneligible": "The technical manager must be a dentist with a CRO.",
      "generic": "Could not complete the action. Try again.",
      "futureAppointments_one": "This member has {{count}} future appointment. Reassign or cancel it before continuing.",
      "futureAppointments_other": "This member has {{count}} future appointments. Reassign or cancel them before continuing.",
      "rolesRequired": "Choose at least one role."
    }
  },
  "admin.home": {
    "title": "Dashboard",
    "welcome": "Hello, {{name}}."
  },
  "admin.login": {
    "forgot": "Forgot password?",
    "title": "Log in",
    "email": "Email",
    "password": "Password",
    "submit": "Log in",
    "passwordSet": "Password set. Log in with the new password.",
    "error": {
      "invalid": "Incorrect email or password.",
      "throttled": "Too many attempts. Wait a minute and try again.",
      "generic": "Could not log in. Try again."
    }
  },
  "admin.notFound": {
    "title": "Page not found",
    "message": "The page you were looking for does not exist or has moved.",
    "home": "Go to the start page"
  },
  "admin.password": {
    "title": "Change password",
    "current": "Current password",
    "new": "New password",
    "confirm": "Confirm new password",
    "submit": "Change password",
    "changed": "Password changed. Your other sessions were signed out.",
    "error": {
      "wrongCurrent": "The current password is incorrect.",
      "tooShort": "The new password must be at least {{min}} characters.",
      "unchanged": "The new password must differ from the current one.",
      "mismatch": "The passwords do not match.",
      "throttled": "Too many attempts. Wait a minute and try again.",
      "generic": "Could not change the password. Try again."
    }
  },
  "admin.profile": {
    "title": "Profile",
    "email": "Email",
    "emailHint": "The email cannot be changed here.",
    "name": "Name",
    "locale": "Language",
    "dateFormat": "Date format",
    "clock": "Clock",
    "dateFormats": {
      "DMY": "Day/month/year",
      "MDY": "Month/day/year",
      "YMD": "Year/month/day"
    },
    "clocks": {
      "24h": "24-hour",
      "12h": "12-hour"
    },
    "submit": "Save",
    "saved": "Profile saved.",
    "error": "Could not save the profile. Try again."
  },
  "admin.staffNew": {
    "title": "New staff account",
    "email": "Email",
    "name": "Name",
    "cro": {
      "legend": "CRO registration (optional)",
      "number": "CRO number",
      "uf": "CRO state",
      "noUf": "State"
    },
    "submit": "Create account",
    "error": {
      "emailTaken": "A staff account with this email already exists.",
      "croPair": "Enter both the CRO number and state, or leave both empty.",
      "generic": "Could not create the account. Try again."
    }
  },
  "admin.staff": {
    "title": "Staff accounts",
    "new": "New account",
    "created": "Account for {{name}} created. Generate the set-password link to hand to them.",
    "search": "Search by name or email",
    "searchSubmit": "Search",
    "empty": "No staff accounts yet.",
    "emptySearch": "No accounts match that search.",
    "hasMore": "There are more accounts than shown. Narrow the search.",
    "col": {
      "name": "Name",
      "email": "Email",
      "cro": "CRO",
      "status": "Status",
      "lastLogin": "Last sign-in",
      "actions": "Actions"
    },
    "status": {
      "active": "Active",
      "pending": "Awaiting password",
      "disabled": "Disabled"
    },
    "action": {
      "link": "Generate set-password link for {{name}}",
      "disable": "Disable {{name}}",
      "enable": "Enable {{name}}"
    },
    "link": {
      "title": "Set-password link for {{name}}",
      "hint": "Hand this link to the person. It is shown only now, works once and expires on {{expires}}. Generating another link voids this one.",
      "choose": "How should {{name}} get the link? Generating a new link voids the previous one.",
      "email": "Send by email",
      "sent": "Link sent to {{email}}, valid until {{expires}}.",
      "sentHint": "If it does not arrive, generate a new link with Copy link: it voids the one sent.",
      "close": "Close",
      "label": "Link",
      "copy": "Copy link",
      "copied": "Link copied."
    },
    "confirm": {
      "title": "Disable {{name}}?",
      "future_one": "{{name}} has {{count}} future appointment. Disabling the account does not cancel or reassign it: it stays on the agenda with no professional to see it. Reassign or cancel it first, or disable anyway.",
      "future_other": "{{name}} has {{count}} future appointments. Disabling the account does not cancel or reassign them: they stay on the agenda with no professional to see them. Reassign or cancel them first, or disable anyway.",
      "submit": "Disable anyway",
      "cancel": "Cancel"
    },
    "error": {
      "load": "Could not load the accounts. Try again.",
      "action": "Could not complete the action. Try again."
    }
  },
  "hub.guard": {
    "loading": "Loading…"
  },
  "hub.layout": {
    "clinicNav": "Clinic",
    "patients": "Patients",
    "agenda": "Agenda",
    "settings": "Settings",
    "logout": "Log out",
    "logoutFailed": "Could not log out. Try again.",
    "switchClinic": "{{name}}, switch clinic",
    "allClinics": "All clinics"
  },
  "hub.shell": {
    "brand": "Takove",
    "skipToContent": "Skip to content"
  },
  "hub.agenda": {
    "title": "Agenda",
    "subtitle": "The clinic's appointments by day or by week.",
    "loading": "Loading the agenda…",
    "loadFailed": "Could not load the agenda.",
    "retry": "Try again",
    "noAccess": "You do not have access to this clinic's agenda.",
    "weekday": {
      "1": "Monday",
      "2": "Tuesday",
      "3": "Wednesday",
      "4": "Thursday",
      "5": "Friday",
      "6": "Saturday",
      "7": "Sunday"
    },
    "toolbar": {
      "label": "Agenda options",
      "view": "View",
      "day": "Day",
      "week": "Week",
      "professional": "Professional",
      "allProfessionals": "Whole clinic",
      "today": "Today",
      "prevDay": "Previous day",
      "nextDay": "Next day",
      "prevWeek": "Previous week",
      "nextWeek": "Next week",
      "new": "New appointment",
      "schedule": "Hours and blocks",
      "rebooking": "Pending rebooking",
      "mode": "Display mode",
      "grid": "Grid",
      "list": "List",
      "rangeDay": "{{from, date}}",
      "rangeWeek": "{{from, date}} to {{to, date}}"
    },
    "filter": {
      "warningsOnly": "Show only appointments with warnings",
      "warningCount_one": "{{count}} with a warning",
      "warningCount_other": "{{count}} with warnings"
    },
    "list": {
      "label": "Agenda for the period",
      "dayHeading": "{{weekday}}, {{date, date}}",
      "today": "Today",
      "closed": "Clinic closed",
      "emptyDay": "No appointments",
      "noWarnings": "No appointment with a warning in this period.",
      "range": "{{start, time}} – {{end, time}}",
      "sentence": "{{patient}}, {{start, time}} to {{end, time}}, {{professional}}, {{status}}"
    },
    "grid": {
      "corner": "Time",
      "dayLabel": "Agenda for {{weekday}}, {{date, date}}",
      "weekLabel": "Week agenda for {{name}}, {{from, date}} to {{to, date}}",
      "dateLine": "{{date, date}}",
      "details": "{{professional}}, {{weekday}}, {{date, date}}, {{start, time}} to {{end, time}}",
      "newSlot": "New appointment, {{professional}}, {{weekday}}, {{date, date}}, {{time, time}}",
      "slotClosed": "outside the clinic's hours",
      "slotOff": "outside the professional's working hours",
      "notes": "Blocks in this period",
      "noteLine": "{{date, date}}: {{note}}",
      "summaryLabel": "Week summary: appointments by professional and day",
      "summaryHint": "Pick a professional to see the week as a grid, or open a day.",
      "summaryProfessional": "Professional",
      "summaryCell_one": "{{professional}}, {{weekday}}, {{date, date}}: {{count}} appointment. Open the day",
      "summaryCell_other": "{{professional}}, {{weekday}}, {{date, date}}: {{count}} appointments. Open the day"
    },
    "announce": {
      "shown_one": "{{count}} appointment in the period",
      "shown_other": "{{count}} appointments in the period",
      "warnings_one": "{{count}} appointment with a warning",
      "warnings_other": "{{count}} appointments with warnings"
    },
    "status": {
      "scheduled": "Scheduled",
      "confirmed": "Confirmed",
      "arrived": "Arrived",
      "in_progress": "In progress",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "no_show": "No-show"
    },
    "flag": {
      "outside_opening_hours": "Outside opening hours",
      "outside_working_hours": "Outside working hours",
      "in_block": "In a block",
      "outcomePending": "Outcome pending",
      "freed": "Time freed"
    },
    "block": {
      "clinic": "Clinic closed: {{what}}",
      "professional": "Block for {{name}}: {{what}}",
      "professionalUnknown": "Professional block: {{what}}",
      "inGrid": "Block: {{what}}",
      "withHours": "{{note}}, {{from, time}} – {{to, time}}",
      "reason": {
        "vacation": "Vacation",
        "absence": "Absence",
        "training": "Training",
        "holiday": "Holiday",
        "closure": "Closure",
        "other": "Other"
      }
    },
    "sheet": {
      "createTitle": "New appointment",
      "create": "Create appointment",
      "noProfessionals": "No professional is available to take appointments.",
      "editTitle": "Appointment of {{patient}}",
      "close": "Close",
      "summary": {
        "status": "Status",
        "day": "Day",
        "time": "Time",
        "professional": "Professional",
        "patient": "Patient",
        "reason": "Reason"
      },
      "statusChanged": "Status changed to {{status}}.",
      "statusGroup": "Change status",
      "noActions": "No status change is available right now.",
      "cancelGroup": "Cancellation reason",
      "noShowGroup": "No-show reason",
      "reasonLabel": "Reason",
      "confirmCancel": "Confirm cancellation",
      "confirmNoShow": "Confirm no-show",
      "back": "Back",
      "reasonRequired": "Choose a reason.",
      "moveGroup": "Move or adjust",
      "save": "Save changes",
      "frozen": "This appointment is finished: its fields are locked.",
      "viewConflict": "View the conflicting appointment",
      "openOtherFailed": "Could not open the appointment.",
      "saved": "Appointment updated.",
      "created": "Appointment created.",
      "withWarning": "{{saved}} Note: {{what}}.",
      "warningAnd": " and "
    },
    "history": {
      "title": "History",
      "loading": "Loading the history…",
      "error": "Could not load the history.",
      "retry": "Try again",
      "empty": "Nothing was recorded before the history began to be kept.",
      "beforeNote": "Nothing was recorded before the first item in this list.",
      "created": "Created as {{status}}",
      "updated": "Changed: {{fields}}",
      "statusChange": "Status: {{from}} → {{to}}",
      "reason": "Reason: {{reason}}.",
      "by": "by {{name}}",
      "field": {
        "time": "time",
        "duration": "duration",
        "professional": "professional"
      }
    },
    "action": {
      "confirmed": "Confirm",
      "arrived": "Mark as arrived",
      "in_progress": "Start the visit",
      "completed": "Complete the visit",
      "cancelled": "Cancel appointment",
      "no_show": "Record no-show",
      "scheduled": "Back to scheduled",
      "restore": "Restore appointment"
    },
    "reason": {
      "cancel": {
        "patient_request": "Patient request",
        "clinic_request": "Clinic request",
        "professional_unavailable": "Professional unavailable",
        "rescheduled_elsewhere": "Rescheduled elsewhere",
        "other": "Other reason"
      },
      "noShow": {
        "no_contact": "No contact",
        "patient_reported": "Patient let us know",
        "other": "Other reason"
      }
    },
    "field": {
      "patient": "Patient",
      "patientRequired": "Choose a patient from the list.",
      "patientEmpty": "No patient found.",
      "patientFailed": "Could not search patients.",
      "status": "Starting status",
      "noShowReason": "No-show reason",
      "professional": "Professional",
      "date": "Date",
      "start": "Start",
      "duration": "Duration",
      "durationMinutes": "Duration in minutes",
      "durationCustom": "Other duration",
      "minutes": "{{n}} min",
      "errors": {
        "required": "Fill in this field.",
        "grid": "Use times in steps of 5 minutes.",
        "range": "The duration must be between 5 and 480 minutes."
      }
    },
    "confirm": {
      "title": "Confirm the time",
      "message": "This time is {{what}}.",
      "saveAnyway": "Save anyway"
    },
    "warning": {
      "outside_opening_hours": "outside the clinic's opening hours",
      "outside_working_hours": "outside the professional's working hours"
    },
    "error": {
      "appointment_warnings": "This time needs to be confirmed.",
      "appointment_changed": "The appointment was changed by someone else. Close and reopen it to see the current version.",
      "appointment_conflict_professional": "This professional already has another appointment at that time.",
      "appointment_conflict_patient": "This patient already has another appointment at that time.",
      "schedule_blocked": "That time falls in a schedule block.",
      "professional_not_eligible": "This professional cannot take appointments.",
      "time_invalid": "Invalid time. Check the date, the start and the duration.",
      "transition_not_allowed": "This status change is not allowed.",
      "time_guard_failed": "This status change is not allowed at this time.",
      "reason_required": "Choose a reason.",
      "reason_invalid": "Choose a valid reason.",
      "initial_status_invalid": "This starting status is not allowed for the chosen time.",
      "appointment_frozen": "This appointment is finished and cannot be changed.",
      "field_not_editable": "This field cannot be changed in this status.",
      "clinic_closed": "The clinic is closed; the agenda cannot be changed.",
      "patient_archived": "This patient's record is archived.",
      "appointment_not_found": "Appointment not found.",
      "patient_not_found": "Patient not found.",
      "unknown": "Could not complete this. Try again."
    }
  },
  "hub.rebooking": {
    "title": "Pending rebooking",
    "subtitle": "Patients whose appointment was cancelled or missed and who have no new appointment. A patient leaves the list when rebooked or after 30 days.",
    "loading": "Loading the list…",
    "loadFailed": "Could not load the list.",
    "retry": "Try again",
    "noAccess": "You do not have access to this clinic's agenda.",
    "back": "Back to the agenda",
    "listHeading": "Patients to rebook",
    "listLabel": "Patients to rebook",
    "empty": "No patients are waiting to be rebooked.",
    "professional": "Professional",
    "allProfessionals": "Whole clinic",
    "none": "No patients to rebook",
    "count_one": "{{count}} patient to rebook",
    "count_other": "{{count}} patients to rebook",
    "when": "{{weekday}}, {{date, date}}, {{start, time}} – {{end, time}}",
    "reason": "Reason: {{reason}}",
    "next": "Next appointment: {{date, date}}, {{time, time}}, {{professional}}",
    "rebook": "Rebook",
    "rebookName": "Rebook {{name}}",
    "more": "Load more",
    "moreFailed": "Could not load more patients.",
    "loadedMore": "{{count}} patients in the list",
    "cleared": "{{name}} was rebooked for {{date, date}} at {{time, time}}. Removed from the list.",
    "stays": "Appointment created for {{name}} on {{date, date}} at {{time, time}}. The patient stays on the list: the new time is not after the missed appointment.",
    "created": "Appointment created.",
    "openOtherFailed": "Could not open the appointment."
  },
  "hub.freeSlots": {
    "open": "Find a free slot",
    "title": "Find a free slot",
    "intro": "Choose the professional and the duration to see the next times that can be booked without a warning.",
    "professional": "Professional",
    "duration": "Duration",
    "minutes": "{{n}} min",
    "results": "Free slots",
    "searching": "Searching for free slots…",
    "none": "No free slot found",
    "found_one": "{{count}} free slot found",
    "found_other": "{{count}} free slots found",
    "slot": "{{weekday}}, {{date, date}}, {{start, time}} to {{end, time}}",
    "empty": "No free slot in the next 14 days for this professional and duration. Try another duration or professional.",
    "failed": "Could not search for free slots.",
    "retry": "Try again",
    "noProfessionals": "No professional can take appointments in this clinic.",
    "close": "Close"
  },
  "hub.clinics": {
    "title": "My clinics",
    "empty": "You are not a member of any clinic yet.",
    "closed": "Closed",
    "roles": {
      "owner": "Owner",
      "dentist": "Dentist"
    }
  },
  "hub.myClinicsLoad": {
    "loading": "Loading your clinics…",
    "loadFailed": "Could not load your clinics.",
    "retry": "Try again"
  },
  "hub.home": {
    "title": "Home"
  },
  "hub.login": {
    "forgot": "Forgot password?",
    "title": "Log in",
    "email": "Email",
    "password": "Password",
    "submit": "Log in",
    "passwordSet": "Password set. Log in with the new password.",
    "error": {
      "invalid": "Incorrect email or password.",
      "throttled": "Too many attempts. Wait a minute and try again.",
      "generic": "Could not log in. Try again."
    }
  },
  "hub.notFound": {
    "title": "Page not found",
    "message": "The page you were looking for does not exist or has moved.",
    "home": "Go to the start page"
  },
  "hub.patientHealth": {
    "loading": "Loading health data…",
    "failed": "Health data could not be loaded. Try again.",
    "notRecorded": "Health data not recorded yet.",
    "reviewed": "Reviewed on {{at}} by {{name}}.",
    "updated": "Last changed on {{at}} by {{name}}.",
    "confirm": "Confirm unchanged",
    "confirmed": "Review confirmed.",
    "confirmFailed": "The review could not be confirmed. Try again.",
    "archivedReadOnly": "Record archived. Read only.",
    "edit": "Edit",
    "editCard": "Edit {{card}}",
    "saved": "{{card}} saved.",
    "notInformed": "Not provided",
    "cards": {
      "allergies": "Allergies",
      "medications": "Current medications",
      "conditions": "Health conditions",
      "pregnancy": "Pregnancy"
    },
    "options": {
      "allergies": {
        "unknown": "Not provided",
        "none": "No known allergies",
        "present": "Has allergies"
      },
      "medications": {
        "unknown": "Not provided",
        "none": "Takes no medication",
        "present": "Takes medication"
      },
      "conditions": {
        "unknown": "Not provided",
        "none": "No conditions",
        "present": "Has health conditions"
      },
      "pregnancy": {
        "unknown": "Not provided",
        "none": "Not pregnant",
        "present": "Pregnant"
      }
    },
    "fields": {
      "status": "Status",
      "allergies": "Which allergies",
      "medications": "Which medications",
      "conditions": "Conditions",
      "conditionsNotes": "Other conditions and current medical treatment",
      "dueDate": "Due date"
    },
    "conditions": {
      "hypertension": "Hypertension",
      "diabetes": "Diabetes",
      "heart_disease": "Heart disease",
      "bleeding_disorder": "Bleeding disorder",
      "anticoagulant_use": "Anticoagulant use",
      "infectious_disease": "Infectious disease",
      "respiratory": "Respiratory disease",
      "epilepsy": "Epilepsy",
      "kidney_disease": "Kidney disease",
      "liver_disease": "Liver disease",
      "bisphosphonate_use": "Bisphosphonate use",
      "immunosuppression": "Immunosuppression",
      "tobacco": "Tobacco use",
      "alcohol": "Alcohol use"
    },
    "pregnancy": {
      "dueDate": "Due on {{date}}",
      "week_one": "Week {{count}} of pregnancy",
      "week_other": "Week {{count}} of pregnancy",
      "noDueDate": "Due date not provided",
      "passed": "Check: the due date has passed."
    },
    "form": {
      "title": "Edit {{card}}",
      "save": "Save",
      "cancel": "Cancel",
      "required": "Fill in this field.",
      "conditionsRequired": "Tick a condition or describe it in the notes.",
      "dueDateInvalid": "Invalid date.",
      "failed": "Could not save. Try again.",
      "archived": "This record was archived and can no longer be edited."
    }
  },
  "hub.patientRecord": {
    "title": "Patient record",
    "loading": "Loading the patient record…",
    "failed": "The patient record could not be loaded. Try again.",
    "notFound": {
      "title": "Patient not found",
      "message": "This record does not exist or does not belong to this clinic.",
      "back": "Back to the patient list"
    },
    "breadcrumb": {
      "label": "You are here",
      "patients": "Patients"
    },
    "archivedBanner": "Record archived on {{at}} by {{name}}. Reason: {{reason}}. Read only.",
    "more": {
      "label": "More actions",
      "text": "More",
      "archive": "Archive record",
      "unarchive": "Unarchive record"
    },
    "archive": {
      "title": "Archive record",
      "body": "The record becomes read only and leaves the list by default. You can unarchive it later.",
      "reason": "Reason",
      "placeholder": "Select a reason",
      "required": "Choose a reason.",
      "confirm": "Archive",
      "failed": "Could not archive. Try again.",
      "futureAppointments_one": "This patient has {{count}} future appointment. Cancel or reschedule it before archiving.",
      "futureAppointments_other": "This patient has {{count}} future appointments. Cancel or reschedule them before archiving.",
      "cancel": "Cancel",
      "reasons": {
        "left_clinic": "Left the clinic",
        "deceased": "Deceased",
        "duplicate": "Duplicate record",
        "created_by_mistake": "Created by mistake",
        "other": "Other"
      }
    },
    "unarchive": {
      "title": "Unarchive record",
      "body": "The record can be edited again and shows in the list.",
      "confirm": "Unarchive",
      "failed": "Could not unarchive. Try again.",
      "done": "Record unarchived."
    },
    "archivedBadge": "Archived",
    "header": {
      "civilName": "Legal name: {{name}}",
      "age_one": "{{count}} year old",
      "age_other": "{{count}} years old",
      "cpf": "CPF {{cpf}}",
      "whatsapp": "WhatsApp",
      "noContact": "No phone or e-mail",
      "noticePending": "Privacy notice pending"
    },
    "tabs": {
      "label": "Patient record sections",
      "later": "{{tab}} (coming soon: {{project}} project)",
      "overview": "Overview",
      "health": "Health",
      "appointments": "Appointments",
      "clinical": "Clinical record",
      "images": "Images",
      "plans": "Treatment plans",
      "finance": "Finance",
      "privacy": "Privacy",
      "projects": {
        "agenda": "Agenda",
        "clinical": "Clinical record",
        "images": "Images",
        "plans": "Procedures and plans",
        "finance": "Finance"
      }
    },
    "overview": {
      "notProvided": "Not provided",
      "edit": "Edit",
      "editCard": "Edit {{card}}",
      "saved": "{{card}} saved.",
      "underageHint": "Patient under 18 with no guardian recorded.",
      "notesHint": "No health information here; use the health tab.",
      "yes": "Yes",
      "no": "No",
      "cards": {
        "identification": "Identification",
        "contact": "Contact and address",
        "guardian": "Guardian",
        "notes": "Administrative notes"
      }
    },
    "fields": {
      "name": "Legal name",
      "socialName": "Social name",
      "sex": "Sex",
      "birthDate": "Birth date",
      "cpf": "CPF",
      "rg": "RG",
      "foreignDocument": "Foreign document",
      "nationality": "Nationality (country code, e.g. BR)",
      "foreign": "Foreign patient",
      "maritalStatus": "Marital status",
      "profession": "Profession",
      "phone": "Phone",
      "phoneHasWhatsapp": "This phone has WhatsApp",
      "email": "E-mail",
      "postalCode": "Postal code (CEP)",
      "street": "Street",
      "number": "Number",
      "complement": "Complement",
      "district": "District",
      "state": "State (UF)",
      "cityIbgeCode": "City",
      "guardianName": "Guardian name",
      "guardianCpf": "Guardian CPF",
      "guardianPhone": "Guardian phone",
      "guardianRelationship": "Relationship",
      "notes": "Notes"
    },
    "address": {
      "search": "Search",
      "noResults": "No results.",
      "cityNeedsState": "Choose the state first."
    },
    "options": {
      "none": "Not provided",
      "sex": {
        "female": "Female",
        "male": "Male",
        "intersex": "Intersex"
      },
      "marital": {
        "single": "Single",
        "married": "Married",
        "stable_union": "Stable union",
        "separated": "Separated",
        "divorced": "Divorced",
        "widowed": "Widowed"
      }
    },
    "form": {
      "title": "Edit {{card}}",
      "save": "Save",
      "saveAnyway": "Save anyway",
      "cancel": "Cancel",
      "open": "Open record",
      "errors": {
        "required": "Fill in this field.",
        "cpfInvalid": "Invalid CPF. Check the 11 digits.",
        "birthDateInvalid": "Invalid date. Use a date between 1900 and today.",
        "phoneInvalid": "Invalid phone. Give the area code, or the country code with +.",
        "emailInvalid": "Invalid e-mail.",
        "postalCodeInvalid": "Invalid postal code. Give 8 digits.",
        "cityNotInState": "Choose a city of the selected state.",
        "countryInvalid": "Give 2 letters, like BR.",
        "notesTooLong": "Use at most 2000 characters.",
        "contactRequired": "Give a phone or an e-mail.",
        "cpfTaken": "This CPF is already registered for {{name}}.",
        "cpfTakenArchived": "This CPF is already registered for {{name}} (archived record)."
      },
      "failed": "Could not save. Try again.",
      "archived": "This record was archived and can no longer be edited.",
      "duplicates": {
        "title": "Similar records exist",
        "body": "Check before saving. The button is now “Save anyway”.",
        "nameBirthDate": "same name and birth date",
        "phone": "same phone",
        "archivedTag": "archived",
        "open": "Open the record of {{name}}"
      }
    }
  },
  "hub.patientAlerts": {
    "title": "Clinical alerts",
    "empty": "No clinical alerts.",
    "meta": "{{name}} on {{at}}",
    "add": "Add alert",
    "resolve": "Resolve",
    "resolveLabel": "Resolve alert: {{text}}",
    "resolved": "Alert resolved.",
    "added": "Alert added.",
    "chips": "Active clinical alerts",
    "addDialog": {
      "title": "Add clinical alert",
      "text": "Alert",
      "hint": "A short notice for the whole team, such as “Allergic to penicillin”. Up to 500 characters.",
      "save": "Add",
      "cancel": "Cancel",
      "required": "Write the alert.",
      "tooLong": "Use at most 500 characters.",
      "failed": "The alert could not be added. Try again.",
      "archived": "This record was archived and can no longer be changed."
    },
    "resolveDialog": {
      "title": "Resolve clinical alert",
      "body": "This alert will stop showing on the record: “{{text}}”",
      "confirm": "Resolve alert",
      "cancel": "Cancel",
      "failed": "The alert could not be resolved. Try again.",
      "archived": "This record was archived and can no longer be changed."
    }
  },
  "hub.patientPrivacy": {
    "title": "Privacy and LGPD",
    "intro": "Legal basis, privacy notice and consents for this patient. Nothing here blocks care.",
    "loading": "Loading privacy…",
    "failed": "Privacy could not be loaded. Try again.",
    "saved": "Entry saved.",
    "none": "No record",
    "basis": {
      "title": "Legal basis of the record",
      "none": "No legal basis recorded.",
      "summary": "{{basis}}, since {{date}}, recorded by {{name}}.",
      "change": "Change legal basis",
      "options": {
        "health_protection": "Health protection",
        "legal_obligation": "Legal or regulatory obligation",
        "contract": "Contract performance",
        "consent": "Consent",
        "other_documented": "Other, documented"
      }
    },
    "notice": {
      "title": "Privacy notice",
      "none": "Notice acknowledgement not recorded yet. Care continues as usual.",
      "summary": "Acknowledged on {{date}}: {{givenBy}}, {{channel}}. Recorded by {{name}}.",
      "record": "Record notice acknowledgement",
      "recordAgain": "Record a new acknowledgement"
    },
    "consents": {
      "title": "Consents beyond care",
      "hint": "The record does not depend on consent. Record only optional uses here.",
      "purposeLabel": "Purpose",
      "stateLabel": "Status",
      "given": "Given on {{date}}",
      "withdrawn": "Withdrawn on {{date}}",
      "give": "Record consent",
      "giveFor": "Record consent: {{purpose}}",
      "withdraw": "Record withdrawal",
      "withdrawFor": "Record withdrawal: {{purpose}}",
      "purposes": {
        "care_record": "Care record",
        "marketing": "Marketing communications",
        "case_showcase_images": "Showing case images",
        "research": "Research"
      }
    },
    "history": {
      "summary": "History ({{count}})",
      "empty": "No events recorded.",
      "kinds": {
        "legal_basis_set": "Legal basis set: {{basis}}",
        "notice_acknowledged": "Notice acknowledgement recorded",
        "consent_given": "Consent given: {{purpose}}",
        "consent_withdrawn": "Consent withdrawn: {{purpose}}"
      },
      "meta": "{{date}}, by {{name}}",
      "wording": "Wording version: {{version}}"
    },
    "givenBy": {
      "patient": "the patient",
      "guardian": "the legal guardian"
    },
    "channel": {
      "written": "in writing",
      "electronic": "electronically"
    },
    "form": {
      "titles": {
        "legal_basis_set": "Change legal basis",
        "notice_acknowledged": "Record notice acknowledgement",
        "consent_given": "Record consent: {{purpose}}",
        "consent_withdrawn": "Record withdrawal: {{purpose}}"
      },
      "basis": "Legal basis",
      "givenBy": "Given by",
      "channel": "How it was recorded",
      "wording": "Version of the text shown",
      "occurredOn": "Date",
      "note": "Note",
      "noteHint": "No health information here.",
      "submit": "Record",
      "cancel": "Cancel",
      "errors": {
        "dateRequired": "Enter the date.",
        "dateFuture": "The date cannot be in the future.",
        "noteRequired": "Explain the documented basis.",
        "noteTooLong": "Use at most 500 characters."
      },
      "failed": "Could not record. Try again.",
      "noConsent": "There is no given consent to withdraw on that date."
    }
  },
  "hub.patientCreate": {
    "title": "New patient",
    "save": "Save",
    "saveAnyway": "Save anyway",
    "cancel": "Cancel",
    "openUnarchive": "Open and unarchive",
    "failed": "Could not register the patient. Try again.",
    "loading": "Loading…",
    "loadFailed": "Could not load the form. Try again.",
    "noAccess": "You do not have permission to register patients.",
    "toast": {
      "title": "Patient registered"
    }
  },
  "hub.patientList": {
    "title": "Patients",
    "subtitle": "The clinic's patient records.",
    "new": "New patient",
    "filter": {
      "label": "Status",
      "active": "Active",
      "all": "Include archived"
    },
    "search": {
      "label": "Search patients",
      "placeholder": "Search by name, CPF or phone…"
    },
    "sort": {
      "menu": "Sort: {{current}}",
      "label": "Sort by",
      "name": "Name (A–Z)",
      "createdAt": "Recently added",
      "updatedAt": "Recently updated"
    },
    "col": {
      "patient": "Patient",
      "contact": "Contact",
      "cpf": "CPF",
      "actions": "Actions"
    },
    "birthDate": "Born: {{date}}",
    "birthDateMissing": "Birth date not provided",
    "contactMissing": "Not provided",
    "cpfMissing": "Not provided",
    "archived": "Archived",
    "open": "Open record",
    "openFor": "Open record of {{name}}",
    "loadMore": "Load more",
    "loading": "Loading patients…",
    "empty": {
      "title": "No patients yet",
      "hint": "Add the clinic's first patient."
    },
    "noResults": {
      "title": "No patients found",
      "hint": "Try another term.",
      "hintArchived": "Try another term or include archived patients."
    },
    "announce": {
      "shown_one": "{{count}} patient shown",
      "shown_other": "{{count}} patients shown",
      "loadedMore_one": "{{count}} patient loaded, {{shown}} shown",
      "loadedMore_other": "{{count}} patients loaded, {{shown}} shown",
      "none": "No patients found"
    },
    "error": {
      "load": "Could not load the patients. Try again.",
      "more": "Could not load more patients. Try again."
    }
  },
  "hub.clinicSettings": {
    "title": "Clinic settings",
    "subtitle": "Opening hours and clinic identity.",
    "loading": "Loading settings…",
    "loadFailed": "Could not load the clinic settings.",
    "retry": "Try again",
    "notInformed": "Not provided",
    "weekday": {
      "1": "Monday",
      "2": "Tuesday",
      "3": "Wednesday",
      "4": "Thursday",
      "5": "Friday",
      "6": "Saturday",
      "7": "Sunday"
    },
    "common": {
      "cancel": "Cancel",
      "save": "Save"
    },
    "hours": {
      "title": "Opening hours",
      "tableLabel": "Opening hours by day",
      "colDay": "Day",
      "colHours": "Hours",
      "closed": "Closed",
      "interval": "{{opensAt, time}} to {{closesAt, time}}",
      "notSet": "Not set",
      "notSetOwner": "Opening hours have not been set yet. Until then, the agenda shows {{from, time}} to {{to, time}} and does not warn about times outside opening hours.",
      "notSetMember": "The clinic owner has not set the opening hours yet. Until then, the agenda shows {{from, time}} to {{to, time}}.",
      "define": "Set hours",
      "edit": "Edit hours",
      "saved": "Opening hours saved",
      "form": {
        "opens": "Opens at",
        "closes": "Closes at",
        "add": "Add interval",
        "addFor": "Add interval: {{day}}",
        "remove": "Remove",
        "removeFor": "Remove interval, {{day}}, {{opensAt, time}} to {{closesAt, time}}",
        "removeBlankFor": "Remove interval {{n}} with no times, {{day}}",
        "caption": "Opening hours, one interval per row",
        "colActions": "Actions",
        "opensFor": "Opens at, {{day}}",
        "closesFor": "Closes at, {{day}}",
        "intervalSuffix": ", interval {{n}}",
        "hint": "Use 5-minute steps. For a lunch break, add two intervals on the same day. A day with no intervals is closed.",
        "failed": "Could not save the hours. Try again.",
        "errors": {
          "week": "Enter at least one opening interval.",
          "incomplete": "Enter the opening and closing times.",
          "grid": "Use 5-minute steps.",
          "order": "The closing time must be after the opening time.",
          "overlap": "This interval overlaps another one on the same day."
        }
      }
    },
    "identity": {
      "title": "Clinic identity",
      "edit": "Edit identity",
      "saved": "Clinic identity saved",
      "hint": "The details the clinic's documents print. All of them are optional.",
      "whatsapp": "WhatsApp",
      "cro": "CRO {{number}}/{{uf}}",
      "croNoUf": "CRO {{number}}",
      "form": {
        "failed": "Could not save the identity. Try again.",
        "whatsapp": "This phone has WhatsApp",
        "none": "None",
        "candidate": "{{name}} — CRO {{cro}}",
        "managerHint": "Pick among the members with the dentist role and a CRO on file.",
        "managerNone": "No member is a dentist with a CRO on file.",
        "cityNeedsState": "Choose the state first.",
        "search": "Search",
        "noResults": "No results.",
        "errors": {
          "required": "Enter the trade name.",
          "cnpjLength": "Incomplete CNPJ. Enter all 14 characters.",
          "cnpjChecksum": "Invalid CNPJ. The check digits do not match, check the number.",
          "phoneInvalid": "Invalid phone. Enter the area code and number.",
          "emailInvalid": "Invalid email.",
          "postalCodeInvalid": "Invalid postal code. Enter the 8 digits.",
          "cityNeedsState": "Choose a municipality of the selected state."
        }
      },
      "fields": {
        "name": "Trade name",
        "legalName": "Legal name",
        "cnpj": "CNPJ",
        "croRegistration": "Clinic CRO registration",
        "phone": "Phone",
        "email": "Email",
        "address": "Address",
        "postalCode": "Postal code (CEP)",
        "street": "Street",
        "number": "Number",
        "complement": "Complement",
        "district": "District",
        "state": "State",
        "city": "City",
        "technicalManager": "Technical manager"
      }
    }
  },
  "hub.schedule": {
    "title": "Hours and blocks",
    "loading": "Loading hours and blocks…",
    "loadFailed": "Could not load the hours and blocks.",
    "retry": "Try again",
    "close": "Close",
    "back": "Back",
    "cancel": "Cancel",
    "save": "Save",
    "weekday": {
      "1": "Monday",
      "2": "Tuesday",
      "3": "Wednesday",
      "4": "Thursday",
      "5": "Friday",
      "6": "Saturday",
      "7": "Sunday"
    },
    "reason": {
      "vacation": "Vacation",
      "absence": "Absence",
      "training": "Training",
      "holiday": "Holiday",
      "closure": "Closure",
      "other": "Other"
    },
    "status": {
      "scheduled": "Scheduled",
      "confirmed": "Confirmed",
      "arrived": "Arrived",
      "in_progress": "In progress",
      "completed": "Completed",
      "cancelled": "Cancelled",
      "no_show": "No-show"
    },
    "hours": {
      "title": "Working hours",
      "professional": "Professional",
      "noProfessionals": "No active professional in this clinic.",
      "notSet": "Not set",
      "notSetText": "{{name}} has no hours of their own and follows the clinic's opening hours.",
      "tableLabel": "Working hours by day",
      "colDay": "Day",
      "colHours": "Hours",
      "closed": "Not working",
      "interval": "{{opensAt, time}} to {{closesAt, time}}",
      "define": "Set hours",
      "edit": "Edit hours",
      "saved": "Working hours saved",
      "form": {
        "title": "Working hours: {{name}}",
        "hint": "Use 5-minute steps. For a lunch break, add two intervals on the same day. A day with no intervals is a day off. The hours may fall outside the clinic's opening hours.",
        "opens": "Starts at",
        "closes": "Ends at",
        "add": "Add interval",
        "addFor": "Add interval: {{day}}",
        "remove": "Remove",
        "removeFor": "Remove interval, {{day}}, {{opensAt, time}} to {{closesAt, time}}",
        "removeBlankFor": "Remove interval {{n}} with no times, {{day}}",
        "caption": "Working hours, one interval per row",
        "colActions": "Actions",
        "opensFor": "Starts at, {{day}}",
        "closesFor": "Ends at, {{day}}",
        "intervalSuffix": ", interval {{n}}",
        "failed": "Could not save the hours. Try again.",
        "forbidden": "You cannot change this professional's hours.",
        "notEligible": "This professional no longer works in this clinic.",
        "errors": {
          "week": "Add at least one working interval.",
          "incomplete": "Enter the start and the end.",
          "grid": "Use 5-minute steps.",
          "order": "The end must be after the start.",
          "overlap": "This interval overlaps another one on the same day."
        }
      }
    },
    "blocks": {
      "title": "Blocks",
      "new": "New block",
      "empty": "No upcoming blocks.",
      "clinic": "Whole clinic",
      "showPast": "Show past blocks",
      "pastTitle": "Past blocks",
      "pastEmpty": "No past blocks.",
      "pastFailed": "Could not load the past blocks.",
      "edit": "Edit",
      "editFor": "Edit block: {{who}}, {{dates}}",
      "remove": "Delete",
      "removeFor": "Delete block: {{who}}, {{dates}}",
      "reasonLabel": "{{reason}}: {{label}}",
      "dates": {
        "day": "{{date}}",
        "days": "{{start}} to {{end}}",
        "timed": "{{date}}, {{start, time}} to {{end, time}}",
        "timedDays": "{{startDate}} {{start, time}} to {{endDate}} {{end, time}}"
      },
      "created": "Block created",
      "updated": "Block saved",
      "deleted": "Block deleted",
      "form": {
        "titleNew": "New block",
        "titleEdit": "Edit block",
        "who": "Who",
        "reason": "Reason",
        "label": "Description (optional)",
        "labelHint": "Shown on the agenda. Do not write health or patient data.",
        "allDay": "Whole day(s)",
        "firstDay": "First day",
        "lastDay": "Last day",
        "startDate": "Start date",
        "startTime": "Start time",
        "endDate": "End date",
        "endTime": "End time",
        "create": "Create block",
        "save": "Save block",
        "failed": "Could not save the block. Try again.",
        "forbidden": "You cannot change this block.",
        "notEligible": "This professional no longer works in this clinic.",
        "notFound": "This block no longer exists. Close and open again.",
        "errors": {
          "required": "Fill in this field.",
          "grid": "Use 5-minute steps.",
          "order": "The end date must be the same as or after the start date.",
          "orderTime": "The end time must be after the start time.",
          "invalid": "This time does not exist in the clinic's time zone.",
          "labelTooLong": "The description can have at most 80 characters."
        }
      },
      "warn": {
        "title_one": "This block covers {{count}} appointment",
        "title_other": "This block covers {{count}} appointments",
        "hint": "The appointments stay as they are and show up as \"in a block\". Move or cancel each one afterwards.",
        "listLabel": "Covered appointments",
        "item": "{{date}}, {{start, time}} to {{end, time}}: {{patient}} with {{professional}} ({{status}})",
        "more_one": "and {{count}} more appointment",
        "more_other": "and {{count}} more appointments",
        "confirmCreate": "Create anyway",
        "confirmSave": "Save anyway",
        "adjust": "Go back and adjust"
      },
      "delete": {
        "title": "Delete block?",
        "body": "The block {{summary}} will be deleted and the time becomes available again.",
        "confirm": "Delete",
        "failed": "Could not delete the block. Try again."
      }
    }
  },
  "public.header": {
    "login": "Sign in"
  },
  "public.shell": {
    "skipToContent": "Skip to content"
  },
  "public.accessibility": {
    "title": "Accessibility statement",
    "commitment": {
      "title": "Our commitment",
      "body": "Takove wants the system to be usable by everyone, including people with disabilities and people who use a screen reader, a keyboard or screen magnification."
    },
    "standard": {
      "title": "Standard and assessment",
      "body": "We aim to follow WCAG 2.2 level AA. This is a self-assessment; the system has not yet been independently audited and we do not claim conformance."
    },
    "gaps": {
      "title": "Known limitations",
      "body": "We are rebuilding the interface. Today the public area has only the home page, this statement and the error page, and we know of no barriers in them. The signed-in screens, such as the agenda below, and the other screens arrive as they are rebuilt, with the same automated checks, which do not replace an independent audit.",
      "agenda": "The clinic agenda (signed-in area, in list and grid views) goes through automated checks (axe, WCAG 2.2 AA) and keyboard tests. It has not yet been tested with screen readers (VoiceOver and NVDA) or on real devices with zoom. The grid is a table of buttons, without the ARIA grid role, until that test is done; the list is the alternative and the default on small screens."
    },
    "contact": {
      "title": "Contact",
      "body": "Found a barrier or need another format? Write to:"
    },
    "lastReviewed": "Last reviewed: October 30, 2026"
  },
  "public.home": {
    "hero": {
      "title": "Hello World",
      "tagline": "Fastify + React + daisyUI"
    }
  },
  "public.notFound": {
    "title": "Page not found",
    "message": "The page you were looking for does not exist or has moved.",
    "home": "Go to the start page"
  },
  "app.footer": {
    "tagline": "A simple way in to find care, professionals and products.",
    "navigation": "Footer links",
    "accessibility": "Accessibility",
    "hub": "Hub",
    "admin": "Admin",
    "build": "Build {{id}}"
  },
  "app.brand": {
    "name": "Takove"
  },
  "forgotPassword": {
    "title": "Forgot your password?",
    "intro": "Enter your account email and we will send a link to set a new password.",
    "email": "Email",
    "submit": "Send link",
    "back": "Back to log in",
    "sent": "If an account exists for this address, we sent a link.",
    "error": {
      "throttled": "Too many attempts. Wait a few minutes and try again.",
      "failed": "Could not send the link. Try again."
    }
  },
  "setPassword": {
    "title": "Set password",
    "checking": "Checking the link…",
    "email": "Email",
    "password": "New password",
    "confirm": "Confirm new password",
    "submit": "Set password",
    "invalid": {
      "title": "Link invalid or expired",
      "message": "This set-password link is not valid or has expired.",
      "forgot": "Request a new link"
    },
    "error": {
      "tooShort": "The password must be at least {{min}} characters.",
      "mismatch": "The passwords do not match.",
      "throttled": "Too many attempts. Wait a minute and try again.",
      "generic": "Could not set the password. Try again."
    }
  },
  "i18n.localeSelect": {
    "label": "Language"
  },
  "common": {
    "save": "Save",
    "cancel": "Cancel",
    "edit": "Edit",
    "delete": "Delete",
    "close": "Close",
    "loading": "Loading…",
    "errorBoundary": {
      "title": "Something went wrong",
      "message": "An unexpected error occurred. Try reloading the page.",
      "reload": "Reload the page",
      "home": "Go to the start page"
    }
  }
}
